export const environment = {
  production: false,

  auth: {
    endpoints: {
      base: 'https://accept-capp.iti.gr/api/auth/',
    }
  },
  api: {
    endpoints: {
      base: 'https://accept-capp.iti.gr/api',
    },
  },
  dateFormat: 'yyyy-MM-dd',
};
